/* eslint-disable no-unused-vars */
/* eslint-disable eqeqeq */
import { Dropdown, Menu, message } from 'antd'
import { getEventTypes, getUnits } from 'core'
import R from 'ramda'
import React, { useCallback, useMemo, useRef, useState } from 'react'
import { connect } from 'react-redux'
import { hasAccesPermits } from 'core/utils'
import * as ScreenPermissions from 'core/EventActions'
import SubMenu from 'antd/lib/menu/SubMenu'
import * as d3selection from 'd3-selection'
import ReactDOM from 'react-dom'
const DailyRectBarList = ({
  data,
  xScale,
  yScale,
  setGraphSelBar,
  graphSelBar,
  setRectHoverData,
  envConfig,
  units,
  selectedEventNum,
  eventTypes,
  setCardEditPromptMode,
  setCardEditPromptRowData,
  setCardEditPrompt,
  actionPermits,
  lock = 'U',
  nameList = [],
  width,
  xMargin,
  yMargin,
  selectedDate,
  setFastRevind,
  graphHeight,
}) => {
  const { card97 = [], graphData = [] } = data
  const [unit, setUnit] = useState('')
  const [utility, setUtility] = useState('') // need to set this
  const [eventNum, setEventNum] = useState(selectedEventNum)
  const { authGodMode } = envConfig

  const isCOPUunit = !!(
    (units.find(u => u.unitId === unit || '') || {}).emsId === 'CO-PU'
  )

  const hasPermissionForCard97 = hasAccesPermits({
    authGodMode,
    actionPermits,
    eventActions: [ScreenPermissions.CARD97_ADMIN],
    matchAny: true,
  })

  const eventId = eventTypes.map(e => e.eventType)
  const outageIds = [
    'SF',
    'U1',
    'U2',
    'U3',
    'MO',
    'PO',
    'PE',
    'ME',
    'IR',
    'MB',
    'RU',
  ]
  const derateIDs = ['D1', 'D2', 'D3', 'D4', 'PD', 'DP', 'DM']

  const eventTypeMap = useMemo(
    _ =>
      R.compose(
        R.fromPairs,
        R.map(e => [e.eventType, e.description])
      )(eventTypes),
    [eventTypes]
  )
  const greenRectRef = useRef()
  const [copiedData, setCopiedData] = useState()
  const getFailCode = (fl = '', eventType) => {
    if (eventType === 'RS') return ''
    else {
      if (fl) return fl.substring(0, 4)
      else return ''
    }
  }
  const getAmpCode = (fl = '', eventType) => {
    if (eventType === 'RS') return ''
    else {
      if ((fl || '').length <= 5) return ''
      else if ((fl || '').length > 5) return (fl || '').substring(5)
    }
  }
  const pasteWork = _ => {
    setCardEditPromptMode('N')
    const { eventNum, eventType, failCode } = copiedData
    const d = card97.find(
      d =>
        d.unitId === copiedData.unit &&
        d.eventNum == eventNum &&
        d.eventIdx === '1'
    )
    setCardEditPromptRowData({
      ...d,
      unit: (unit || '').length > 3 ? unit : d.utility + d.unit,
      failCode: getFailCode(failCode, eventType),
      ampCode: getAmpCode(failCode, eventType),
      conCode: '1',
    })
    setCardEditPrompt(true)
    setCopiedData()
  }
  const START = 'START'
  const END = 'END'
  const [dragType, setDragType] = useState(START)
  const [isDraging, setIsDraging] = useState(false)

  // const getMousePosition = evt => {
  //   var CTM = svg.getScreenCTM()
  //   return {
  //     x: (evt.clientX - CTM.e) / CTM.a,
  //     y: (evt.clientY - CTM.f) / CTM.d,
  //   }
  // }

  const dragRect = useRef()
  const position = useCallback(
    (e, hourVal) => {
      const xVal = xScale(parseInt(hourVal))
      if (!dragRect.curren) return {}
      const node = ReactDOM.findDOMNode(dragRect.current)
      const position = d3selection.clientPoint(node, e)

      const width = xVal - position[0]

      const xPoint = position[0] / xScale.bandwidth()
      const retValue = { x: position[0], y: position[1], xVal, xPoint, width }

      return retValue
    },
    [xScale]
  )

  const dragStart = _ => setIsDraging(true)
  const dragEnd = _ => setIsDraging(false)

  const dragProp = useCallback(
    (dragType, event) => {
      // setDragType(dragType)

      // if (event && !isDraging) setIsDraging({ ...event, width })

      return {
        onMouseDown: e => {
          // console.log(dragType, 'mouse down')
          dragStart()
        },
        onMouseMove: e => {
          // console.log('mouse Move')
          const { width } = position(
            e,
            dragType === START ? isDraging.startHour : isDraging.endHour
          )
          setIsDraging({ ...event, width })
        },
        onMouseOut: e => {
          // console.log('mouse Out')
          dragEnd()
        },
        onMouseLeave: e => {
          // console.log('mouse leave')
          dragEnd()
        },
        onMouseUp: e => {
          // console.log('mouse up')
          dragEnd()
        },
      }
    },
    [isDraging, position]
  )

  return (
    <g key="menu">
      <Dropdown
        key="drop"
        overlay={
          <Menu
            onClick={({ key }) => {
              // this.setState({ mode: key, promptNew: true })
              // console.log(key)

              if (key === 'start') {
                setFastRevind(graphSelBar.eventStart)
              } else if (key === 'end') {
                setFastRevind(graphSelBar.eventEnd)
              } else if (key === 'copy') {
                setCopiedData(graphSelBar)
              } else if (key === 'paste') {
                pasteWork()
              } else if (['E', 'V', 'D'].includes(key)) {
                if (eventNum == -1) {
                  message.warn('Please,Select Data')
                  return
                }
                setCardEditPromptMode(key)
                const d = card97.find(
                  d =>
                    d.eventNum == eventNum &&
                    d.eventIdx === '1' &&
                    d.unitId === unit
                )
                setCardEditPromptRowData({ ...d, unit: d.utility + d.unit })
                setCardEditPrompt(true)
              } else {
                const availCap = [
                  'SF',
                  'U1',
                  'U2',
                  'U3',
                  'MO',
                  'PO',
                  'SE',
                  'ME',
                  'PE',
                  'RS',
                  'IR',
                  'MB',
                  'RU',
                ].includes(key)
                  ? '0'
                  : undefined
                setCardEditPromptMode('N')
                setCardEditPromptRowData({
                  year: selectedDate.format('YYYY'),
                  utility,
                  unit,
                  eventType: key,
                  availCap,
                  eventNum: -1,
                  causeCode:
                    key === 'RS'
                      ? '0'
                      : key === 'CO'
                      ? '9340'
                      : key === 'PU'
                      ? '9345'
                      : undefined,
                  description: key === 'RS' ? 'Reserve Shutdown' : undefined,
                  eventStart: selectedDate.format('YYYY-MM-DD'),
                  conCode: '1',
                })
                setCardEditPrompt(true)
              }
            }}
          >
            <Menu.Item key="V" disabled={eventNum == -1}>
              View
            </Menu.Item>
            <Menu.Item key="copy" disabled={eventNum == -1}>
              Copy
            </Menu.Item>
            <Menu.Item key="paste" disabled={!copiedData}>
              Paste
            </Menu.Item>
            <Menu.Item
              key="E"
              disabled={
                !hasPermissionForCard97 || eventNum == -1 || lock === 'L'
              }
            >
              Update
            </Menu.Item>
            <Menu.Divider />
            <Menu.Item
              key="D"
              disabled={
                !hasPermissionForCard97 || eventNum == -1 || lock === 'L'
              }
            >
              Delete
            </Menu.Item>
            <Menu.Divider />
            <Menu.Item
              key="RS"
              disabled={
                !hasPermissionForCard97 && (eventNum == -1 || lock === 'L')
              }
            >
              Add Reserve Shutdown
            </Menu.Item>
            <SubMenu
              title="Add Outage Event"
              // disabled={lock === 'L'}
              disabled={
                !hasPermissionForCard97 && (eventNum == -1 || lock === 'L')
              }
            >
              {outageIds
                .filter(o => eventId.includes(o))
                .map(o => (
                  <Menu.Item key={o}>
                    {o} - {eventTypeMap[o]}
                  </Menu.Item>
                ))}
            </SubMenu>
            <SubMenu
              title="Add Derate Event"
              disabled={
                !hasPermissionForCard97 && (eventNum == -1 || lock === 'L')
              }
            >
              {derateIDs
                .filter(o => eventId.includes(o))
                .map(o => (
                  <Menu.Item key={o}>
                    {o} - {eventTypeMap[o]}
                  </Menu.Item>
                ))}
            </SubMenu>
            <Menu.Item
              key="NC"
              disabled={
                !hasPermissionForCard97 && (eventNum == -1 || lock === 'L')
              }
            >
              Add Non-Curtailing Event
            </Menu.Item>
            {isCOPUunit && (
              <SubMenu
                title="Add CO/PU Event"
                disabled={
                  !hasPermissionForCard97 && (eventNum == -1 || lock === 'L')
                }
              >
                <Menu.Item key="CO">CO - Condensing</Menu.Item>
                <Menu.Item key="PU">PU - Pumping</Menu.Item>
              </SubMenu>
            )}
            <Menu.Item key="start" disabled={eventNum == -1}>
              Fast Rewind to Event Start
            </Menu.Item>
            <Menu.Item key="end" disabled={eventNum == -1}>
              Fast Rewind to Event End
            </Menu.Item>
          </Menu>
        }
        trigger={['contextMenu']}
        // visible={this.state.visibleMenu || false}
      >
        <g>
          <rect
            id="greenrect"
            ref={greenRectRef}
            x={xScale(0)}
            y={yScale(nameList[0])}
            height={graphHeight - xMargin}
            width={width - yMargin}
            fill="#07e92b"
            onContextMenu={e => {
              const node = ReactDOM.findDOMNode(greenRectRef.current)
              const position = d3selection.clientPoint(node, e)
              const domaintIndex = position[1] / yScale.bandwidth()
              const shortName = nameList[parseInt(domaintIndex)]
              const un = units.find(u => u.shortName === shortName)

              setUnit(un && un.unitId)
              setUtility(un && un.utility)
              setEventNum(-1)
            }}
            onClick={_ => {
              // const node = ReactDOM.findDOMNode(greenRectRef.current)
              // const position = d3selection.clientPoint(node, e)
              // const domaintIndex = position[1] / yScale.bandwidth()
              // const shortName=nameList[parseInt(domaintIndex)]
              // console.log(domaintIndex, shortName)
              // const un=units.find(u=>u.shortName===shortName)
              // setUnit(un.unitId)
              // setUtility(un.utility)
            }}
          />
          <g id="hline">
            {R.range(1, 25).map(h => (
              <line
                key={h + 'hline'}
                x1={xScale(h)}
                y1={yScale(nameList[0])}
                x2={xScale(h)}
                y2={
                  nameList.length > 0
                    ? yScale(nameList[nameList.length - 1]) + yScale.bandwidth()
                    : 0
                }
                style={{ stroke: 'rgb(0, 0, 0)', strokeWidth: 1 }}
              />
            ))}
          </g>
          <g id="vline">
            {nameList.map(h => (
              <line
                key1={h}
                key={h + 'vline'}
                x1={xScale(0)}
                y1={yScale(h)}
                x2={xScale(24)}
                y2={yScale(h)}
                style={{ stroke: 'rgb(0, 0, 0)', strokeWidth: 1 }}
              />
            ))}
            <line
              key="last-vline"
              x1={xScale(0)}
              y1={yScale.bandwidth() * nameList.length}
              x2={xScale(24)}
              y2={yScale.bandwidth() * nameList.length}
              style={{ stroke: 'rgb(0, 0, 0)', strokeWidth: 1 }}
            />
          </g>
          {graphData.map((gr, idx) => {
            const { stripeRed, stripeGreen, stripeBlue } = gr
            const { red, green, blue } = gr
            // const { startHour, endHour } = gr
            // const { year, unitId, eventNum } = gr
            const isStripLine = !!stripeRed
            let fill = ''
            if (!isStripLine) {
              fill = `rgb(${red},${green},${blue})`
            } else {
              // eslint-disable-next-line eqeqeq
              fill = `url(#${stripeRed}${stripeGreen}${stripeBlue})`
            }

            return (
              <g key={eventNum + '' + idx} id="data">
                {/* <line x1="0" y1="0" x2="200" y2="200" style="stroke:rgb(255,0,0);stroke-width:2" /> */}
                <rect
                  key={eventNum + 'rc'}
                  fill={fill}
                  x={xScale(parseFloat(gr.startHour))}
                  y={yScale(gr.shortName)}
                  height={yScale.bandwidth()}
                  width={
                    xScale(parseFloat(gr.endHour)) -
                    xScale(parseFloat(gr.startHour))
                  }
                  onClick={_ => {
                    const selCard97 = card97.find(
                      f => f.unitId === gr.unitId && f.eventNum == gr.eventNum
                    ) || { eventNum: -1, unitId: '', unit: '', utility: '' }
                    setUnit(selCard97.unitId)
                    setUtility(selCard97.utility)
                    setGraphSelBar(selCard97)
                  }}
                  onMouseEnter={_ => {
                    if (gr) {
                      const selCard97 = card97.find(
                        f => f.unitId === gr.unitId && f.eventNum == gr.eventNum
                      ) || { eventNum: -1 }
                      setRectHoverData(selCard97)
                    }
                  }}
                  onMouseLeave={_ => setRectHoverData({})}
                  eventNum={gr.eventNum}
                  unitId={gr.unitId}
                  onContextMenu={_ => {
                    // setEventNum(e.target.getAttributeNS(null, 'eventNum'))
                    // setUnit(e.target.getAttributeNS(null, 'unitId'))
                    const selCard97 = card97.find(
                      f => f.unitId === gr.unitId && f.eventNum == gr.eventNum
                    ) || { eventNum: -1, unitId: '' }

                    setUnit(selCard97.unitId)
                    setUtility(selCard97.utility)
                    setEventNum(selCard97.eventNum)
                    setGraphSelBar({ ...selCard97, unit: selCard97.unitId })
                  }}
                />
                {/* <rect
                  key={eventNum + 'rc-start'}
                  x={xScale(parseFloat(gr.startHour))}
                  y={yScale(gr.shortName)}
                  height={yScale.bandwidth()}
                  width={2}
                  fill="yellow"
                  eventNum={eventNum + '-' + idx}
                  shortName={gr.shortName}
                  {...dragProp(START)}
                /> */}
                {/* <rect
                  key={eventNum + 'rc-end'}
                  eventNum={eventNum + '-' + idx}
                  shortName={gr.shortName}
                  x={xScale(parseFloat(gr.endHour))}
                  y={yScale(gr.shortName)}
                  height={yScale.bandwidth()}
                  width={2}
                  fill="yellow"
                  {...dragProp(END)}
                /> */}
              </g>
            )
          })}
          {/* {isDraging && (
            <rect
              ref={dragRect}
              id="drag-rect"
              x={
                dragType === START
                  ? xScale(parseFloat(isDraging.startHour))
                  : xScale(parseFloat(isDraging.endHour))
              }
              y={yScale(isDraging.shortName)}
              height={yScale.bandwidth()}
              width1={isDraging.width}
              width={isDraging.width ? xScale(isDraging.width) : 0}
              fill="black"
            />
          )} */}
        </g>
      </Dropdown>
    </g>
  )
}

const mapStateToProps = state => ({
  eventTypes: getEventTypes(state),
  units: getUnits(state),
})

export default connect(mapStateToProps)(DailyRectBarList)
